import { useQuery } from '@tanstack/react-query';
import { getSetupIpaBasicConfig, SETUP_IPA_BASIC_CONFIG_QUERY_KEY } from '../../../Administrador/Produtos/Components/SetupIpaBasicConfig/service';
import { normalizePriceMode } from '../priceMode';

// Mesma chave da tela de Configurações Básicas: salvar lá atualiza o modo lido aqui.
export function usePriceMode() {
  return useQuery({
    queryKey: SETUP_IPA_BASIC_CONFIG_QUERY_KEY,
    queryFn: getSetupIpaBasicConfig,
    select: config => normalizePriceMode(config?.adjustemend_price_mode),
  });
}
